import { RewardRarity } from "../client/generated/graphql";
import { getColor } from "./color";

export const rarityToColorMapping: Record<RewardRarity, string> = {
    [RewardRarity.Uncommon]: "LIGHTGREEN_600",
    [RewardRarity.Rare]: "BLUE_600",
    [RewardRarity.Epic]: "DEEPPRUPLE_600",
    [RewardRarity.Legendary]: "ORANGE_600"
}

export const getRewardColorCode = (rarity: RewardRarity) => rarityToColorMapping[rarity];
export const getRewardColor = (rarity: RewardRarity) => getColor(getRewardColorCode(rarity));